import React from "react";
import _ from "lodash";
import SessionStore from "../../../../services/session/SessionStore";
import { SOCIAL_POSTER_PERMISSION, SOCIAL_COMMENTER_PERMISSION, MANAGE_EXTERNAL_ACCOUNTS } from "../../socialConstants";
import { socialEngagementAllowed, socialPublishingAllowed, socialCommentingAllowed } from "../../../app/site/featureAccessControl";


/**
 * here be various helper configuration functions. If you want a component to be reactive to updates in values,
 * make it a mobx observable
 */

export function canApprove() {
  const user = SessionStore.user;
  return !!user && _.intersection(user.permissions, [
    SOCIAL_POSTER_PERMISSION
  ]).length > 0;
}

export function canApproveResponses() {
  const user = SessionStore.user;
  return !!user && _.intersection(user.permissions, [
    SOCIAL_COMMENTER_PERMISSION
  ]).length > 0;
}

/**
 * NOTE: returns true if the user can draft posts OR if they can post directly
 */
export function canDraft() {
  return socialPublishingAllowed()
}

/**
 * NOTE: returns true if the user can draft responses OR if they can response directly
 */
export function canDraftResponses() {
  return socialCommentingAllowed()
}

export function canSubmitPost() {
  const user = SessionStore.user;
  return canApprove();
}

export function canReply({item}) {
  return item.canReply
}

export function canDeletePendingReply({ item }) {
  const user = SessionStore.user;
  return canApproveResponses() || item.postToBePublished && item.postToBePublished.userId === user.userId;
}

/*
 * For determining if a post, simply can't be replied to.
 */
export function cantReplyThroughDashboard({item}) {
  return (canSubmitPost() || canApprove() || isPublishingFeature()) && !canReply({item})
}


export function canHaveLikes({item}) {
  // all providers and all levels of posts currently support this
  return true;
}

export function canLike({item}) {
  return item.provider !== 'Instagram' && item.provider !== 'Google'
}

export function canRetweet({item}) {
  if (item.provider === 'Twitter') return true;
  else {
    if (item.provider.toLowerCase() === 'linkedin') {
      const hasAttachment = item.attachments.length > 0;
      const isRoot = item.ancestorIds.length <= 0;
      // TODO: #linkedin re-enable when LinkedIn stops throwing a 500, internal server error on re-shares.
      // return hasAttachment && isRoot
      return false;
    } else return false;
  }
}

export function hasWorkflow2Enabled() {
  const config = SessionStore.brandConfig;
  return !!config && !!config.restrictions && !config.restrictions.hideWorkflow2;
}
export function canWorkflow() {
  const user = SessionStore.user;
  return !!user && user.permissions.indexOf('ShowWorkflow') !== -1 && hasWorkflow2Enabled();
}

export function isPublishingFeature() {
  const account = SessionStore.account;
  return !!account && account.services && account.services.socialCommenting;
}

export function isSocialPublishing() {
  const account = SessionStore.account;
  return !!account && account.services && (account.services.socialPublishing || account.services.socialEngagement);
}

/** @deprecated - use featureAccessControl */
export function isSocialEngagement() {
  return socialEngagementAllowed();
}
